import React from "react";
import { NavDropdown } from "react-bootstrap";

const ResourcesNavBar = () => {
  return (
    <NavDropdown title="RPG Resources" id="rpg-resources-nav-dropdown">
      <NavDropdown title="Role Playing Games" id="rpg-resources-rpg-dropdown">
        <NavDropdown.Item href="./game-rundown">Game Rundown</NavDropdown.Item>
      </NavDropdown>
    </NavDropdown>
  );
};

export default ResourcesNavBar;
